/**
 * API Configuration
 * Base URL and authentication token management
 */

const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
  endpoints: {
    // Admin Authentication only
    login: '/api/admin/login',
  }
};

/**
 * Get authentication token from localStorage
 */
export const getAuthToken = () => {
  return localStorage.getItem('authToken') || '';
};

/**
 * Set authentication token in localStorage
 */
export const setAuthToken = (token) => {
  localStorage.setItem('authToken', token);
};

/**
 * Remove authentication token from localStorage
 */
export const removeAuthToken = () => {
  localStorage.removeItem('authToken');
};

/**
 * Get base URL
 */
export const getBaseUrl = () => {
  return API_CONFIG.baseUrl;
};

/**
 * Build full URL for an endpoint
 * Ensures the URL is always absolute (starts with http:// or https://)
 */
export const buildUrl = (endpoint) => {
  let baseUrl = API_CONFIG.baseUrl;
  
  // Ensure baseUrl is absolute (starts with http:// or https://)
  // If not, default to localhost
  if (!baseUrl.startsWith('http://') && !baseUrl.startsWith('https://')) {
    baseUrl = 'http://localhost:3000';
  }
  
  // Ensure endpoint starts with /
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  
  // Remove trailing slash from baseUrl if present
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  
  return `${cleanBaseUrl}${cleanEndpoint}`;
};

/**
 * Get headers for authenticated requests
 */
export const getAuthHeaders = (includeContentType = true) => {
  const headers = {};
  
  if (includeContentType) {
    headers['Content-Type'] = 'application/json';
  }
  
  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  return headers;
};

/**
 * Get headers for form-data requests (multipart/form-data)
 */
export const getFormDataHeaders = () => {
  const headers = {};
  const token = getAuthToken();
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  // Don't set Content-Type for FormData - browser will set it with boundary
  return headers;
};

export default API_CONFIG;

